(function () {
  'use strict';

  angular
    .module('app.product.reviews', [])

    .component('productReviews', {
      bindings: {
        id: '=idProduct',
        message: '@',
        js: '@'
      },
      /* @ngInject */
      templateUrl: ["$sce", function ($sce) {
        return $sce.trustAsResourceUrl('/Template/Reviews/Reviews');
      }],
      controllerAs: 'reviewsCtrl',
      /* @ngInject */
      controller: ["$scope", "LoadService", function ($scope, LoadService) {
        var ctrl = this;
        ctrl.$onInit = function () {
          LoadService.getService('AsyncReviewsService', { ctrl: ctrl, scope: $scope }, 'initModule');
        };
      }]
    })

    .directive('reviewsLink', ["ModalService", function (ModalService) {
      return {
        restrict: 'A',
        scope: true,
        bindToController: true,
        controllerAs: 'ctrl',
        controller: function () {
          var ctrl = this;

          ctrl.openReview = function (event, id, designation) {
            event.preventDefault();
            event.stopPropagation();
            ModalService.show(
              '/Reviews/' + id + '?view=ModalReviews',
              {
                designation: designation
              },
              'lg'
            );
          };
        }
      };
    }])

    /* @ngInject */
    .controller('formReviewsController', ["LoadService", function (LoadService) {
      var ctrl = this;
      ctrl.init = function (js, id, url, token, message) {
        ctrl.js = js;
        ctrl.id = id;
        ctrl.url = url;
        ctrl.token = token;
        ctrl.messageOK = message;
        LoadService.getService('AsyncReviewsService', { ctrl: ctrl }, 'initForm');
      };
    }]);
})();
